import './requestRegister.scss'
import React, { useState, useEffect } from 'react'
import { Button, Container, Grid, Box, Typography } from '@material-ui/core'
import { Search, Check, CheckCircleOutlined } from '@material-ui/icons'
import Two from '../../assets/Images/two.png'
import Three from '../../assets/Images/three.png'
import LinearProgress from '@material-ui/core/LinearProgress'

const { REACT_APP_STRAPI_API_URL } = process.env

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="text.secondary">
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  )
}
function RequestRegister() {
  const [progress, setProgress] = React.useState(10)

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress(prevProgress =>
        prevProgress >= 100 ? 10 : prevProgress + 10
      )
    }, 800)
    return () => {
      clearInterval(timer)
    }
  }, [])

  const [usBetters, setUsBetter] = useState()
  const getUsBetterData = async () => {
    const response = await fetch(
      `${REACT_APP_STRAPI_API_URL}/api/us-betters?populate=Image`
    ).then(response => response.json())
    setUsBetter(response?.data)
  }
  useEffect(() => {
    getUsBetterData()
  }, [])

  const [searchDomainTitle, setSearchDomainTitle] = useState()
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${REACT_APP_STRAPI_API_URL}/api/search-domain-titles`
        )
        const json = await response.json()
        setSearchDomainTitle(json?.data[0]?.attributes)
      } catch (error) { }
    }
    fetchData()
  }, [])

  const [buttons, setButton] = useState()
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${REACT_APP_STRAPI_API_URL}/api/button-apis`
        )
        const json = await response.json()
        setButton(json?.data[0]?.attributes)
      } catch (error) { }
    }
    fetchData()
  }, [])

  const [showElement, setShowElement] = React.useState(true)
  useEffect(() => {
    setTimeout(function () {
      setShowElement(false)
    }, 8000)
  }, [])
  return (
    <>
      <div class="borderboxwrap">
        <div class="title-col1">
          <Typography variant="h1">{searchDomainTitle?.title}</Typography>
        </div>
        <form class="searchcolwrap">
          <input type="search" name="search" placeholder="Search" />
          <Button class="btnstyle">
            <a href="/requestRegister2">
              <Search />
              {buttons?.avax}
            </a>
          </Button>
        </form>
        <section className="register">
          <Container>
            <Grid item xs={12}>
              <Typography variant="h1">{searchDomainTitle?.ProgressTitle}</Typography>
            </Grid>
            {showElement ? (
              <div className="bar">
                <Box>
                  <LinearProgressWithLabel value={progress} />
                </Box>
              </div>
            ) : (
              <div className="finishprocess">
                <Typography variant="h4">Click “Register Now” to finish process{'>'}</Typography>
                <Button class="btnstyle2">
                  <a href="/transferData">
                    <Check />
                    {buttons?.now}
                  </a>
                </Button>
              </div>
            )}

            <Grid style={{ display: 'flex', flexWrap: 'wrap' }}>
              <Grid container item xl={4} lg={4} md={4} sm={12} xs={12}>
                <div className="registerCard">
                  <div>
                    <CheckCircleOutlined />
                    <div className="iconcirclecol" />
                    <Typography variant="h4">Start to register</Typography>
                    <Typography component="p">
                      Your wallet will open and you will be asked to confirm the
                      first of two transactions required for registration. If
                      the second transaction is not processed within 24 hours of
                      the first, you will need to start again from step 1.
                    </Typography>
                  </div>
                </div>
              </Grid>
              <Grid container item xl={4} lg={4} md={4} sm={12} xs={12}>
                <div className="registerCard">
                  <div>
                    {progress > 60 ? (
                      <>
                        <CheckCircleOutlined />
                        <div className="iconcirclecol" />
                      </>
                    ) : (
                      <img src={Two} alt=" " class="img-fluid" />
                    )}
                    <Typography variant="h4">Wait One Minute</Typography>
                    <Typography component="p">
                      The waiting period is required to ensure another person
                      hasn't tried to register the same name and protect you
                      after your request.
                    </Typography>
                  </div>
                </div>
              </Grid>
              <Grid container item xl={4} lg={4} md={4} sm={12} xs={12}>
                <div className="registerCard">
                  <div>
                    <img src={Three} alt=" " class="img-fluid" />
                    <Typography variant="h4">Complete Registration</Typography>
                    <Typography component="p">
                      Click 'register' and your wallet will re-open. Only after
                      the 2nd transaction is confirmed you'll know if you got
                      the name.
                    </Typography>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Container>
        </section>
        <section className="usBetter">
          <Container>
            <Grid item xs={12}>
              <Typography variant="h1">{searchDomainTitle?.usbetterTitle}</Typography>
            </Grid>
            <Grid style={{ display: 'flex', flexWrap: 'wrap' }}>
              {usBetters &&
                usBetters.map(usBetter => (
                  <Grid container item xl={3} lg={3} md={3} sm={12} xs={12}>
                    <div className="usBetterDetail">
                      <img
                        src={
                          REACT_APP_STRAPI_API_URL +
                          usBetter?.attributes?.Image?.data[0]?.attributes.url
                        }
                        alt=" "
                        class="img-fluid"
                      />
                      <Typography variant="h2">{usBetter.attributes.name}</Typography>
                      <Typography component="p">{usBetter.attributes.content}</Typography>
                    </div>
                  </Grid>
                ))}
            </Grid>
          </Container>
        </section>
      </div>
    </>
  )
}

export default RequestRegister